module.exports = __webpack_public_path__ + "img/bell.6db2a0f9.svg";